import { always } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import Button from '../../../../../../../../Form/Button';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import { LearningCollectionEditFormResource } from '../../../../../../Edit/Store/Types';
import { ModifiableExperiencesContext } from '../../../../../../Types';
import Store from '../../../Store';
import {
  addProgramTask,
  ExperienceResource,
  programLicensedTask,
  warningModelTask,
} from '../../../Types';
import OverviewPdfLink from '../../OverviewPdfLink';

interface Props {
  store: Store;
  resource: ExperienceResource;
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
  open: () => void;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

export const addProgram =
  (
    store: Store,
    learningCollectionStore: LearningCollectionEditStore,
    context: ModifiableExperiencesContext,
    resource: ExperienceResource,
    open: () => void,
    learningCollectionEditFormResource: LearningCollectionEditFormResource,
  ) =>
  () =>
    programLicensedTask(resource)
      .andThen(() => warningModelTask(learningCollectionEditFormResource))
      .fork(
        () => addProgramTask(resource, store, learningCollectionStore, context),
        () => open(),
      );

const buttonCSS =
  'w-fit cursor-pointer rounded-lg border px-5 py-2.5 text-sm font-light tracking-wide';
function ActionButton({
  learningCollectionStore,
  context,
  resource,
  open,
  store,
  learningCollectionEditFormResource,
}: Props) {
  return (
    <div className="flex items-center">
      {learningCollectionStore
        .selectedExperience(context, resource)
        .map(() => (
          <Button
            type="button"
            value="Remove program"
            onClick={() => learningCollectionStore.removeExperienceStore(context, resource)}
            className={clsx('border-red-600 text-red-600', buttonCSS)}
          />
        ))
        .getOrElse(() => (
          <Button
            type="button"
            value="Add program"
            onClick={addProgram(
              store,
              learningCollectionStore,
              context,
              resource,
              open,
              learningCollectionEditFormResource,
            )}
            className={clsx('bg-green-600 text-white', buttonCSS)}
          />
        ))}
      <div
        className={clsx(
          learningCollectionStore
            .selectedExperience(context, resource)
            .map(always('opacity-50'))
            .getOrElseValue(''),
        )}
      >
        <OverviewPdfLink links={resource.links} />
      </div>
    </div>
  );
}

export default observer(ActionButton);
